import { connect } from 'react-redux';

import FamilyCategory from './familyCategory';
import { getProductsStatus, getProductsData, getIsStockOrder, getCategoryCommentsData, getCategoryCommentsStatus } from '../../store/selectors';
import { loadProducts, loadCategoryComments } from '../../store/action-creators';

const mapStateToProps = (state) => ({
  productsStatus: getProductsStatus(state),
  productsData: getProductsData(state),
  categoryCommentsStatus: getCategoryCommentsStatus(state),
  categoryCommentsData: getCategoryCommentsData(state),
  isStockOrder: getIsStockOrder(state), 
});

const mapDispatchToProps = {
  loadProducts,
  loadCategoryComments,
}

export default connect(mapStateToProps, mapDispatchToProps)(FamilyCategory);